import type { QueryOptions } from '@tanstack/react-query'
import type { ExactPartial } from '@wagmi/core/internal'

import { Evaluate } from 'viem'
import {
  type GetEVCTransactionErrorErrorType,
  type GetEVCTransactionErrorParameters,
  type GetEVCTransactionErrorReturnType,
  getEVCTransactionError,
} from '../actions/getEVCTransactionError'
import type { ExtendedConfig, ScopeKeyParameter } from '../types'
import { filterQueryOptions } from '../utils'

export type GetEVCTransactionErrorOptions = Evaluate<ExactPartial<GetEVCTransactionErrorParameters> & ScopeKeyParameter>

export function getEVCTransactionErrorQueryKey(options: GetEVCTransactionErrorOptions = {}) {
  const { hash, ...parameters } = options
  return [
    'eVCTransactionError',
    filterQueryOptions({
      hash,
      ...parameters,
    }),
  ] as const
}

export function getEVCTransactionErrorQueryFn(
  config: ExtendedConfig,
  options: GetEVCTransactionErrorOptions = {},
): ReturnType<typeof getEVCTransactionError> {
  const { ...parameters } = options
  return getEVCTransactionError(config, parameters)
}

export function getEVCTransactionErrorQueryOptions<config extends ExtendedConfig>(
  config: config,
  options: GetEVCTransactionErrorOptions,
): QueryOptions<
  GetEVCTransactionErrorQueryFnData,
  GetEVCTransactionErrorErrorType,
  GetEVCTransactionErrorData,
  GetEVCTransactionErrorQueryKey
> {
  return {
    gcTime: 0,
    queryFn: async ({ queryKey }) => {
      return getEVCTransactionErrorQueryFn(config, queryKey[1])
    },
    queryKey: getEVCTransactionErrorQueryKey(options),
  }
}

export type GetEVCTransactionErrorQueryFnData = GetEVCTransactionErrorReturnType

export type GetEVCTransactionErrorData = GetEVCTransactionErrorQueryFnData

export type GetEVCTransactionErrorQueryKey = ReturnType<typeof getEVCTransactionErrorQueryKey>
